var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgC4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.2512 16.5112C37.1025 16.49 36.9537 16.49 36.805 16.5112C33.5112 16.405 30.8975 13.7062 30.8975 10.3912C30.8975 7.0125 33.6387 4.25 37.0387 4.25C40.4175 4.25 43.18 6.99125 43.18 10.3912C43.1587 13.7062 40.545 16.405 37.2512 16.5112Z",
    fill: "#FFBD0F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1787 31.2374C41.7987 32.8311 38.4624 33.4261 35.3812 33.0224C36.1887 31.2799 36.6137 29.3461 36.6349 27.3061C36.6349 25.1811 36.1674 23.1624 35.2749 21.3986C38.4199 20.9736 41.7562 21.5686 44.1574 23.1624C47.5149 25.3724 47.5149 29.0061 44.1787 31.2374Z",
    fill: "#FFBD0F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6851 16.5112C13.8338 16.49 13.9826 16.49 14.1313 16.5112C17.4251 16.405 20.0388 13.7062 20.0388 10.3912C20.0388 6.99125 17.2976 4.25 13.8976 4.25C10.5188 4.25 7.77759 6.99125 7.77759 10.3912C7.77759 13.7062 10.3913 16.405 13.6851 16.5112Z",
    fill: "#FFBD0F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9186 27.3063C13.9186 29.3675 14.3649 31.3225 15.1724 33.0863C12.1761 33.405 9.05238 32.7675 6.75738 31.2588C3.39988 29.0275 3.39988 25.3938 6.75738 23.1625C9.03113 21.6325 12.2399 21.0163 15.2574 21.3563C14.3861 23.1413 13.9186 25.16 13.9186 27.3063Z",
    fill: "#FFBD0F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.755 33.7237C25.585 33.7025 25.3937 33.7025 25.2025 33.7237C21.2924 33.5962 18.1687 30.3875 18.1687 26.435C18.19 22.3975 21.4412 19.125 25.5 19.125C29.5375 19.125 32.8099 22.3975 32.8099 26.435C32.7887 30.3875 29.6862 33.5962 25.755 33.7237Z",
    fill: "#FFBD0F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8487 38.1226C15.64 40.2689 15.64 43.7964 18.8487 45.9214C22.5037 48.3651 28.4962 48.3651 32.1512 45.9214C35.36 43.7751 35.36 40.2476 32.1512 38.1226C28.5175 35.6789 22.525 35.6789 18.8487 38.1226Z",
    fill: "#FFBD0F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC4);
export default __webpack_public_path__ + "static/media/C4.dbf058582ec83afbdff034375c74e081.svg";
export { ForwardRef as ReactComponent };